import styles from '../../styles/products.module.css';
import { KR } from '../../constants/localizations';

export default function ProductDeliveryRobotBoxDetail() {
    return (
        <div className={styles.robotDetails}>
            <div className={styles.robotDLeft}>
                <div className={styles.flexBox}>
                    <span>{KR.label_products_detail_robot_size}</span>
                    <span>610(w)x750(d)x850(h)mm</span>
                </div>
                <div className={styles.flexBox}>
                    <span>{KR.label_products_detail_box_size}</span>
                    <span>400mm x 480mm x 340mm</span>
                </div>
                <div className={styles.flexBox}>
                    <span>{KR.label_products_detail_max_quantity}</span>
                    <span>20kg</span>
                </div>
                <div className={styles.flexBox}>
                    <span>{KR.label_products_detail_speed}</span>
                    <span>0km/h ~ 5km/h (최대 7km/h)</span>
                </div>
                <div className={styles.flexBox}>
                    <span>{KR.label_products_detail_angle}</span>
                    <span>9°</span>
                </div>
                <div className={styles.flexBox}>
                    <span>{KR.label_products_detail_sensor}</span>
                    <span>2D 카메라·3D 라이다·초음파</span>
                </div>
            </div>
            <div className={styles.robotDRight}>
                <div className={styles.label}>
                    <span>제품 주요</span>
                    <span>기능 및 특징</span>
                </div>
                <div className={styles.labelContent}>
                    <span>
                        국내 유일 완전 자율주행 로봇 (한국로봇산업진흥원)
                    </span>
                    <span>
                        실외이동로봇 운행안전인증서 (Safety Certificate for Outdoor Mobile Robot)
                    </span>
                    <span>
                        라스트마일 배송 서비스 시장의 단점을 보완하고,비용절감, 효율성 개선 등 실외/실내 반경 1km 내 단거리 배송에 최적화된 배송 로봇시스템
                    </span>
                    <span>
                        친환경 저속 안전주행 로봇 운행으로 지역 거주민 및 첨단 도시 이미지 조성
                    </span>
                </div>
            </div>
        </div >
    )
}
